// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/post-hello-request-schema',
  type: 'object',
  required: ['hello'],
  properties: {
    hello: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
